import React from 'react';
import PropTypes from 'prop-types';
import {
	Header, SubHeader,
	OrDivider, Form,
	Button, Footer,
	Bold, Cta,
} from '../loginStyles';
import SocialButtons from '../SocialButtons';
import Input from '../Input';
import Password from '../Password';
import {
	SmallPrint, Link,
} from './createAccountStyles';

import { SIGN_IN } from '../actions';
import Checkbox from '../Checkbox';
import Spinner from 'core/components/Spinner';
import Emailcheck from '../Emailcheck';

const CreateAccount = ({
	facebookClick, googleClick,
	changeCurrent, outsideUsa,
	email, createAccountPassword,
	fullName, inputChangeHandler,
	createAccountHandler,
	wantsPromotions, loading,
	createAccountError, createAccountMsg,
	modalMode, fillSuggestedEmail,
	hasEmailError, hasFullNameError,
}) => (
	<>
		{modalMode && (
			<div>
				<Header>Create a free account</Header>
				<SubHeader>Create an account for the best experience, exclusive deals & spoilers, and manage all your subscriptions in one place. </SubHeader>
			</div>
		)}

		<SocialButtons facebookClick={facebookClick} googleClick={googleClick} signUp />
		<OrDivider />

		<Form className="createAccountForm" onSubmit={createAccountHandler}>
			<Input
				type="text"
				name="fullName"
				placeholder="Full Name"
				value={fullName}
				onChange={inputChangeHandler}
				autoComplete="name"
				errorMsg={hasFullNameError && createAccountError ? createAccountMsg : null}
			/>
			<Emailcheck email={email} zIndex={modalMode ? 0 : -1} shouldHide={createAccountError} fillSuggestedEmail={fillSuggestedEmail}>
				<Input
					type="email"
					name="email"
					placeholder="Email Address"
					value={email}
					onChange={inputChangeHandler}
					errorMsg={hasEmailError && createAccountError ? createAccountMsg : null}
					autoComplete="username"
				/>
			</Emailcheck>

			<Password
				type="password"
				placeholder="Password"
				name="createAccountPassword"
				value={createAccountPassword}
				onChange={inputChangeHandler}
				autoComplete="new-password"
			/>

			{outsideUsa && (
				<Checkbox
					value={wantsPromotions}
					name="wantsPromotions"
					onChange={inputChangeHandler}>
					Yes, sign me up for awesome promotions from Cratejoy!
				</Checkbox>
			)}

			<Button id="register" type="submit" disabled={loading}>
				{loading ? <Spinner /> : 'Sign up'}
			</Button>

			<SmallPrint>
				By registering, you agree to our <Link href="/sell/terms/">Terms of Use</Link>, <Link href="/sell/privacy/">Privacy Policy</Link>, and to receive emails that you can unsubscribe from at any time.
			</SmallPrint>

			<Footer fullWidth={!modalMode}>
				<Bold>Have an account?</Bold>
				<Cta className="loginSignInBtn" onClick={changeCurrent(SIGN_IN)} disabled={loading} type="button">Sign in</Cta>
			</Footer>
		</Form>
	</>
);

CreateAccount.propTypes = {
	facebookClick: PropTypes.func,
	googleClick: PropTypes.func,
	changeCurrent: PropTypes.func,
	outsideUsa: PropTypes.bool,
	inputChangeHandler: PropTypes.func,
	createAccountHandler: PropTypes.func,
	email: PropTypes.string,
	fullName: PropTypes.string,
	createAccountPassword: PropTypes.string,
	wantsPromotions: PropTypes.bool,
	loading: PropTypes.bool.isRequired,
	createAccountError: PropTypes.bool,
	createAccountMsg: PropTypes.string,
	modalMode: PropTypes.bool,
	fillSuggestedEmail: PropTypes.func,
	hasEmailError: PropTypes.bool,
	hasFullNameError: PropTypes.bool,
};

export default CreateAccount;
